import { getImageSrc } from './../../../../wix-rich-content-common/lib/imageUtils';

import type { GalleryItem } from '../common-types';

export const getMediaSrc = ({
  item,
  requiredWidth,
  requiredHeight,
}: {
  item: GalleryItem;
  requiredWidth: number;
  requiredHeight: number;
}) => {
  if (item && item.video) {
    return item?.video?.thumbnail?.src?.url;
  }

  const src = item?.image?.media?.src?.id || item?.image?.media?.src?.url || '';

  return getImageSrc(
    {
      file_name: src,
      id: src,
      width: item?.image?.media?.width,
      height: item?.image?.media?.height,
    },
    undefined,
    {
      requiredWidth,
      requiredHeight,
      requiredQuality: 80,
    }
  );
};

const arrayMoveMutable = <T>(array: T[], fromIndex: number, toIndex: number) => {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
};

export const arrayMoveImmutable = <T>(
  array: readonly T[],
  fromIndex: number,
  toIndex: number
): T[] => {
  const newArray = [...array];
  arrayMoveMutable(newArray, fromIndex, toIndex);
  return newArray;
};
